const { api } = useFeathers()

export const useViewerStore = defineStore('viewer', {
  state: () => ({
    dialog: false,
    error: '',
    id: null as null | number,
    file: null as null | string,
    loading: false,
  }),
  getters: {},
  actions: {
    async reset() {
      this.$reset()
    },
    async preview(id: number) {
      this.$patch({ dialog: true, id, loading: true })
      try {
        const boxFile = await api.service('cc/box').download(id)
        if (boxFile.Data) {
          const file = URL.createObjectURL(new Blob([boxFile.Data as any], {
            type: 'application/pdf',
          }))
          this.$patch({ file })
        }
      }
      catch (e: any) {
        // quietly ignore loading error
        this.$patch({ error: e.message })
      }
      finally {
        this.$patch({ loading: false })
      }
    },
  },
})
